﻿import React, { Fragment } from 'react';

export function Numeric(
    {
        children
    }
) {

    return (<Fragment>{formatStringToNumeric(children)}</Fragment>);

    function formatStringToNumeric(value) {
        if (value == null || isNaN(value)) {
            return "-";
        }
        else {
            return new Intl.NumberFormat('en-GB').format(value)
        }
    }
}

Numeric.propTypes = {
};